import {useMemo} from 'react';
import {useTheme} from '@mui/material';
import type {ThesaurusAction} from 'types';
import type {SceneExtensionCore} from 'sceneExtensions/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import type {ThesaurusValue} from 'schemaDefinition/types';
import type {
  ThesaurusEditContainerConfig,
  ThesaurusFieldConfig,
} from '../types';
import {ThesaurusEditContainer} from '../ThesaurusEditContainer';
import {useThesaurusMetadataFieldExtension} from './useThesaurusMetadataFieldExtension';

export const useThesaurusEditSceneExtensionCore = (
  config?: ThesaurusEditContainerConfig,
) => {
  const thesaurusMetadataFieldExtension = useThesaurusMetadataFieldExtension();
  const {palette} = useTheme();

  return useMemo((): SceneExtensionCore<
    FieldExtensionEnum.thesaurusEdit,
    ThesaurusValue,
    ThesaurusValue,
    ThesaurusAction,
    ThesaurusFieldConfig
  > => {
    return {
      type: FieldExtensionEnum.thesaurusEdit,
      panelConfig: {
        backgroundColour: palette.background.brown.level1,
      },
      renderRightPanel: (onClose: () => Promise<void>) => (
        <ThesaurusEditContainer onClose={onClose} config={config} />
      ),
      fieldContext: thesaurusMetadataFieldExtension,
    };
  }, [palette, thesaurusMetadataFieldExtension, config]);
};
